/* Foundry Insights - thin API map over the portal HttpClient (sets the /api base URL,
 * attaches the Bearer token, handles 401 -> logout). Mirrors the .NET
 * FoundryInsightsController routes (api/foundry-insights/*). Separate report from
 * Manufacturing Insights (its own 'foundry-insights' report-access key + 'Foundry' role). */
import httpClient from "@/assets/js/HttpClient";

const B = "/foundry-insights";
const get = (path) => httpClient.get(B + path).then((r) => r.data);

export default {
  health: () => get("/health"),
  freshness: () => get("/freshness"),
  provenance: () => get("/provenance"),
  kpis: () => get("/kpis"),
  overview: () => get("/overview"),

  shipped: () => get("/shipped"),
  shippedDaily: (y, m) => get(`/shipped/daily/${y}/${m}`),
  partsSales: () => get("/parts-sales"),
  partsInvoices: (y, m) => get(`/parts-sales/invoices/${y}/${m}`),
  labor: () => get("/labor"),
  hrsPerTon: () => get("/hrs-per-ton"),
  laborWeekly: (dept) => get(`/labor/weekly/${encodeURIComponent(dept)}`),
  scrap: () => get("/scrap"),
  scrapTop: () => get("/scrap/top"),
  scrapTrend: (dim, key) => get(`/scrap/trend/${encodeURIComponent(dim)}/${encodeURIComponent(key)}`),
  scrapBreakdown: () => get("/scrap/breakdown"),
  chrome: () => get("/chrome"),
  chromeDetail: (y, m) => get(`/chrome/detail/${y}/${m}`),
  inventory: () => get("/inventory"),
  meltRatio: () => get("/melt-ratio"),

  // Profitability tab (Foundry P&L: production cost/lb, cost split, YTD vs PY)
  profitability: () => get("/profitability"),
  profitabilityStatement: (y, m) => get(`/profitability/statement/${y}/${m}`),

  // report-access gate (reuses the existing portal endpoint / 'foundry-insights' key)
  accessMine: () => httpClient.get("/report/access/mine").then((r) => r.data),
};
